import styled from 'styled-components'

export const BackgroundDiv = styled.div`
  background-image: url('${props => props.image}');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`
